<template>
    <div class="main" :class="this.$i18n.locale=='tc'?'font-NotoSansTC':'font-roboto'">
        <div class="main_header">
            <img src="https://img.tsimtech.com/vue/img/Tsim_Logo2x.png" class="logo">
            <a-dropdown :trigger="['click']">
                <img src="@/assets/images/language.png" class="lang">
                <a-menu slot="overlay">
                    <a-menu-item @click="selectLang('tc')" :class="this.$i18n.locale=='tc'?'item_active':''">
                        繁体中文
                    </a-menu-item>
                    <a-menu-item @click="selectLang('en')" :class="this.$i18n.locale=='en'?'item_active':''">
                        English
                    </a-menu-item>
                    <a-menu-item @click="selectLang('kr')" :class="this.$i18n.locale=='kr'?'item_active':''">
                        한국어
                    </a-menu-item>
                    <a-menu-item @click="selectLang('jp')" :class="this.$i18n.locale=='jp'?'item_active':''">
                        日本語
                    </a-menu-item>
                </a-menu>
            </a-dropdown>
            
        </div>
        <div class="main_banner">
            <div class="banner_content">
                <a-row type="flex" align="middle" justify="center">
                    <a-col :xs="0" :sm="0" :md="isIphone?0:12" :lg="isIphone?0:12" :xl="{span:isIphone?24:12}" class="center" > 
                        <div class="title" :class="this.$i18n.locale=='tc'?'titleFont_nt7':'titleFont_rb7'">
                            {{ $t('collectingInformation.collaboration') }}
                            <div>
                                {{ $t('collectingInformation.wonderfuljourney') }}
                            </div>
                        </div>
                    </a-col>
                    <a-col :xs="24" :sm="24" :md="isIphone?24:12" :lg="isIphone?24:12" :xl="{span:isIphone?24:12}" class="center">
                        <img src="@/assets/images/collectionBanner.png" alt="">
                    </a-col>
                </a-row>
            </div>
        </div>
        <div class="tip_message">
            <p>
                {{ $t('collectingInformation.workingdays') }}
            </p>
            <p :class="this.$i18n.locale=='tc'?'titleFont_nt7':'titleFont_rb7'">
                {{ $t('collectingInformation.expandingbusiness') }}
            </p>
        </div>
        <div class="main_content">
            <div class="optionCard">
                <div class="content">
                    <a-row type="flex" align="middle" justify="center">
                        <a-col :xs="24" :sm="24" :md="isIphone?0:12" :lg="isIphone?0:12" :xl="isIphone?24:12" class="opt">
                            <div class="select_role">
                                <div class="rolePng"><img src="@/assets/images/role_Clients.png" alt=""></div>
                                <div v-html="$t('collectingInformation.ourclients')" :class="this.$i18n.locale=='tc'?'titleFont_nt7':'titleFont_rb7'"></div>
                                <p>{{ $t('collectingInformation.optimalbusiness') }}</p>
                                <a-button @click="showPartnerFormModal">{{ $t('collectingInformation.startednow') }}</a-button>
                            </div>
                        </a-col>
                        <a-col :xs="24" :sm="24" :md="isIphone?24:12" :lg="isIphone?24:12" :xl="isIphone?24:12" class="opt">
                            <div class="select_role">
                                <div class="rolePng"><img src="@/assets/images/role_Providers.png" alt=""></div>
                                <div v-html="$t('collectingInformation.oursuppliers')" :class="this.$i18n.locale=='tc'?'titleFont_nt7':'titleFont_rb7'"></div>
                                <p>{{ $t('collectingInformation.businessopportunities') }}</p>
                                <a-button @click="showProviderFormFormModal">{{ $t('collectingInformation.startednow') }}</a-button>
                            </div>
                        </a-col>
                    </a-row>
                </div>
            </div>
            
        </div>
        <div class="footer" v-html="$t('collectingInformation.contactus')"></div>
        <div class="fix_footer">
            {{ $t('collectingInformation.copyright') }}
        </div>
        <partner-form ref="partnerform"></partner-form>
        <provider-form ref="providerForm"></provider-form>
    </div>
</template>

<script>
import partnerForm from './components/partnerForm.vue'
import providerForm from './components/providersForm.vue'
import { checkIsIPhone } from '@/utils/reg'

    export default {
        components: {
            partnerForm,
            providerForm,
            isIphone:false,//苹果手机对插件不兼容，只能用判断是否是苹果手机另做修改
        },
        mounted () {
            this.$i18n.locale = localStorage.getItem('collecting') || 'en'
        },
        created() {
            const setLocale = (locale) => {
                this.$i18n.locale = locale;
                localStorage.setItem('collecting', locale);
            };
            const loacles = this.$route.params.loacles || 'en'; // 设置默认值为 'en'
            const role = this.$route.params.role;
            if (role === 'clients' || role === 'suppliers') {
                this.$nextTick(() => {
                    switch (loacles) {
                        case 'tc':
                            setLocale('tc');
                            break;
                        case 'en':
                            setLocale('en');
                            break;
                        case 'jp':
                            setLocale('jp');
                            break;
                        case 'kr':
                            setLocale('kr');
                            break;
                        default:
                            setLocale('en');
                            break;
                    }
                    // 根据不同角色显示对应的 modal
                    if (role === 'clients') {
                        this.$refs.partnerform.showModal();
                    } else if (role === 'suppliers') {
                        this.$refs.providerForm.showModal();
                    }
                });
            }
            this.checkIphone();
        },
        methods: {
            checkIphone(){
                if(checkIsIPhone()){
                    this.isIphone = true
                }else{
                    this.isIphone = false
                }
            },
            selectLang(lang){
                this.$i18n.locale = lang
                localStorage.setItem('collecting',lang)
            },
            showPartnerFormModal(){
                this.$refs.partnerform.showModal()
            },
            showProviderFormFormModal(){
                this.$refs.providerForm.showModal()
            },
        }
    }
</script>

<style lang="less" scoped>
.main{
    width: 100%;
    height: 100vh;
    background-color: #ffffff;
    &.font-roboto{
        font-family: 'Roboto-Regular';
    }
    &.font-NotoSansTC{
        font-family: 'NotoSansTC-Regular';
    }
    .titleFont_rb7{
        font-family: 'Roboto-Bold';
    }
    .titleFont_nt7{
        font-family: 'NotoSansTC-Bold';
    }
    .titleFont_rb6{
        font-family: 'Roboto-SemiBold';
    }
    .titleFont_nt6{
        font-family: 'NotoSansTC-SemiBold';
    }
    .titleFont_rb5{
        font-family: 'Roboto-Medium';
    }
    .titleFont_nt5{
        font-family: 'NotoSansTC-Medium';
    }
}

.main_header{
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    .logo{
        width: 52px;
        height: 40px;
        margin-top: 9px;
    }
    .lang{
        width: 25px;
        height: 25px;
        margin-top: 15px;
    }
}

.item_active{
    background-color: #f49b23;
    color: #ffffff;
}

.main_banner{
    width: 100%;
    padding: 20px;
    background-color: #f5f7fa;
    .banner_content{
        width: 610px;
        margin: 0 auto;
    }
    img{
        width: 360px;
        height: 234px;
    }
    .center{
        display: flex;
        justify-content: center;
        align-content: center;
    }
    .title{
        width: 260px;
        color: #f49b23;
        font-size: 26px;
        // font-weight: 700;
        line-height: 32px;
        div{
            margin-top: 10px;
            font-size: 18px;
            color: black;
            line-height: 30px;
        }
    }
    
}

.tip_message{
    padding: 0 10px;
    margin-top: 15px;
    text-align: center;
    font-size: 13px;
}

.main_content{
    display: flex;
    justify-content: center;
    align-items: center;
    .optionCard{
        width: 590px;
        margin: 0 20px;
        .content{
            .opt{
                padding: 0px 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                /deep/.select_role{
                    width: 330px;
                    padding: 20px;
                    background-color: #f5f7fa;
                    border-radius: 10px;
                    margin-bottom: 10px;
                    .rolePng{
                        text-align: center;
                        img{
                            width: 100px;
                            height: 100px;
                        }
                    }
                    h1{
                        font-size: 15px;
                        span{
                            color: #f49b23;
                        }
                    }
                    p{
                        font-size: 12px;
                        padding: 0 10px;
                        min-height: 45px;
                    }
                    .ant-btn{
                        width: 100%;
                        height: 34px;
                        background-color: #f49b23;
                        color: #ffffff;
                    }
                    .ant-btn:hover, .ant-btn:focus{
                        border-color: #f49b23;
                    }
                }
            }
        }
        
    }
}
/deep/.footer{
    width: 360px;
    padding-bottom: 10px;
    text-align: center;
    margin: 0 auto;
    padding: 15px;
    font-size: 13px;
    a{
        color: #f49b23;
    }
}
.fix_footer{
    width: 100%;
    text-align: center;
    margin: 0 auto;
    padding: 15px;
    background-color: #f5f7fa;
    font-size: 12px;
}


/deep/.ant-dropdown-menu-item{
    font-size: 14px !important;
    padding: 10px 20px !important;
}
/deep/ .ant-dropdown-menu-item-active{
    background-color: #f49b23 !important;
    color: #ffffff !important;
}


@media (max-width: 475px){
    .main_header{
        height: 62Px;
    }
}

@media (max-width: 992px){
    .main_banner{
        .banner_content{
            width: 100%;
        }
        .title{
            font-size: 25px;
            line-height: 27px;
            text-align: center;
            div{
                font-size: 16px;
            }
        }
    }
    .tip_message{
        font-size: 16px;
    }
    .main_content{
        .optionCard{
            .content{
                .opt{
                    /deep/.select_role{
                        h1{
                            font-size: 18px;
                        }
                        p{
                            font-size: 16px;
                        }
                        .ant-btn{
                            font-size: 18px;
                            height: 40px;
                        }
                    }
                }
                
            }
        }
    }
    /deep/.footer{
        font-size: 14px;
        a{
            color: #f49b23;
        }
    }
    .fix_footer{
        font-size: 14px;
    }
}
</style>